import React from 'react';
import AppConfig from '../domain/AppConfig';
import AppService from '../service/AppService';
import {Message} from '@aperza/ui';

export default class LogoutLink extends React.Component {

  render() {

    let appConfig:AppConfig = AppService.appConfig();

    let encodedPath = "";
    let path = (location.pathname + location.search).replace(/^\/+/, "");
    if( path !== "/" ){
      encodedPath = encodeURIComponent(path);
    }

    let domain = appConfig.baseComDomain;
    let protocol = 'https';
    let port = '';
    if (domain.includes('.local.')) {
      protocol = 'http';
      port = ':8000';
    }

    let url = `${protocol}://id${appConfig.baseComDomain}${port}/logout/${appConfig.serviceType}?path=${ document.domain.match(/order/) ? "" : encodedPath}`;

    return (
      <div className="logOut">
        <a  data-tracking-action="usermenu_logout" href={url}>
          <Message messageId="userMenu.logout" />
        </a>
      </div>
    )
  }

}
